import React from 'react';

type Props = React.PropsWithChildren<{}>

const FormErrorMessage: React.FunctionComponent<Props> = ({ children }) => (
  <span className="tw-text-red-700">{children}</span>
);

export default FormErrorMessage;
